/* eslint-disable default-param-last */
/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
import { AxiosError } from "axios";
import { HttpRequestGet, HttpRequestPost, HttpRequestPut } from "../../service";
import { CollectOrderStatus } from "../../components-molecules/CollectOrderStamp";
import { VehicleTypeSource } from "../../components-molecules/VehicleTypeSelector";

export interface GetOrdersRequestModel {
  Query?: string;
  Size: number;
  Page: number;
  Order: string;
  Filter: {
    Status?: string[];
    StartDate?: Date;
    EndDate?: Date;
    Merchants?: string[];
  };
}

export interface CollectOrderListModel {
  Id: string;
  MerchantName: string;
  BookedBy: string;
  ReferenceNumber: string;
  PickUpTime: string;
  Drafted: string;
  Failed: string;
  VehicleTypeCode: string;
  CustomerEmail: string;
  CustomerFirstName: string;
  CustomerLastName: string;
  OrderValue: number;
  PortalStatus: string;
  Status: CollectOrderStatus;
  PremiumSelected?: boolean;
  LatestUpdateForArchived: string;
  ManuallyResolved?: boolean;
}

export interface CollectOrderRootModel {
  TotalCountByMerchant: number;
  Merchant: string;
  Deliveries: CollectOrderListModel[];
}
export interface GetOrderResultModel {
  Data: CollectOrderRootModel[];
  Count: number;
}

export interface GetOrdersResponseModel {
  Result: string | GetOrderResultModel;
  Route: string;
}
export function GetCollectOrders(
  url: string = "open",
  data: GetOrdersRequestModel,
  callback: (resp: GetOrderResultModel) => void,
  errCallback: (err: GetOrdersResponseModel) => void
) {
  HttpRequestPost(
    `/collect/list/${url}`,
    () => undefined,
    (response: GetOrdersResponseModel) => {
      callback(response.Result as GetOrderResultModel);
    },
    (err: GetOrdersResponseModel) => errCallback(err),
    true,
    data
  );
}

export interface ICreateCollectOrder {
  Route: string;
  Result: string;
}

export function CreateCollectOrder(
  data: any,
  // eslint-disable-next-line no-unused-vars
  callback: (resp: string) => void,
  failCallback: (resp: string) => void
) {
  HttpRequestPost(
    "/collect",
    () => undefined,
    (response: ICreateCollectOrder) => {
      callback(response.Result);
    },
    (err: any) => failCallback(err),
    true,
    data
  );
}

export type VehicleType =
  | "motorcycle"
  | "car"
  | "van_small"
  | "van"
  | "35t_van"
  | "xlwb"
  | "box_truck";

export interface IGetVehicleTypeModel {
  Id: number;
  Code: string;
  IconUrl: string;
  FullIconUrl: string;
  Name: string;
  Active: boolean;
  MaxSize: string;
  MaxWeight: string;
  MaxLength: string;
  Info: string;
  Speed: string;
  Availability: string;
  Example: string;
  VolumetricEngineVehicleId?: number | null;
}

export interface IGetVehicleTypesResponseModel {
  Route: string;
  Result: IGetVehicleTypeModel[];
}

export function getVehicleTypes(
  source: VehicleTypeSource,
  success: (response: any) => void,
  failure: (error: AxiosError<any>) => void
): void {
  const url = source === VehicleTypeSource.TK_COLLECT ? `/collect/vehicle-type` : `/shop/delivery/vehicle-type`;
  HttpRequestGet(
    url,
    () => undefined,
    (response: IGetVehicleTypesResponseModel) => success(response.Result),
    (error: any) => failure(error),
    true
  );
}

export interface IGetCollectionContactDetailsModel {
    FirstName: string;
    LastName: string;
    Phone: string;
  }

  export interface IGetCollectionContactDetailsResponseModel {
    Route: string;
    Result: IGetCollectionContactDetailsModel;
  }

  export function getCollectionContactDetails(
    success: (response: IGetCollectionContactDetailsModel) => void,
    failure: (error: AxiosError<any>) => void
  ): void {
    HttpRequestGet(
      `/collect/collection-contact-details`,
      () => undefined,
      (response: IGetCollectionContactDetailsResponseModel) => success(response.Result),
      (error: any) => failure(error),
      true
    );
  }

export function getQuote(
  body: any,
  success: (response: any) => void,
  failure: (error: AxiosError<any>) => void
): void {
  HttpRequestPost(
    `/collect/${body.orderId}/quote`,
    () => undefined,
    (response: any) => {
      success(response.Result);
    },
    (err: any) => failure(err),
    true,
    body
  );
}

export function placeCollectOrder(
  body: any,
  success: (response: any) => void,
  failure: (error: AxiosError<any>) => void
): void {
  HttpRequestPost(
    `/collect/place`,
    () => undefined,
    (response: any) => success(response.Result),
    (error: any) => failure(error),
    true,
    body
  );
}
export interface IDeliveryStatusType {
  Id: number;
  Name: string;
  Code: string;
}

export interface IDeliveryStatusResponseModel {
  Route: string;
  Result: IDeliveryStatusType[];
}

export function getDeliveryStatusTypes(
  success: (response: IDeliveryStatusType[]) => void,
  failure: (error: AxiosError<any>) => void
): void {
  HttpRequestGet(
    `/collect/delivery-status-type`,
    () => undefined,
    (response: IDeliveryStatusResponseModel) => success(response.Result),
    (error: any) => failure(error),
    true
  );
}

export function getMerchantFilters(
  success: (response: any[]) => void,
  failure: (error: AxiosError<any>) => void
): void {
  HttpRequestGet(
    `/collect/merchant/list`,
    () => undefined,
    (response: any) => success(response.Result),
    (error: any) => failure(error),
    true
  );
}

export function acceptTerms(
  success: (response: any[]) => void,
  failure: (error: AxiosError<any>) => void
): void {
  HttpRequestPost(
    `/portal/accept-terms`,
    () => undefined,
    (response: any) => success(response.Result),
    (error: any) => failure(error),
    true,
    {}
  );
}

export interface ICancelOrderCreationBody {
  orderId?: string;
}

export interface CancelOrderErrorModel {
  Result: string;
  Route: string;
}

export function cancelOrderCreation(
  data: ICancelOrderCreationBody,
  callback: (resp: GetOrderResultModel) => void,
  errCallback: (err: string) => void
) {
  HttpRequestPost(
    `/collect/${data.orderId}/cancel`,
    () => undefined,
    (response: any) => {
      callback(response.Result);
    },
    (err: string) => errCallback(err),
    true,
    {}
  );
}

export interface ShopAddressResponse {
  Id: string;
  Name: string;
  AddressLine1: string;
  AddressLine2: string;
  AddressLine3: string;
  PostCode: string;
  City: string;
  County: string;
  Long: number;
  Lat: number;
}

export function getShopAddress(
  success: (response: any) => void,
  failure: (error: AxiosError<any>) => void
): void {
  HttpRequestGet(
    `/shop/address`,
    () => undefined,
    (response: { Result: ShopAddressResponse }) => success(response.Result),
    (error: any) => failure(error),
    true
  );
}

export function acceptOrderCreation(
  orderId: string,
  code: string,
  data: any,
  callback: (resp: any) => void
) {
  delete data.Name;
  delete data.Line3;

  const url =
    code === "pickup_location_changed"
      ? "update-pickup-address"
      : "update-dropoff-address";

  HttpRequestPut(
    `/collect/${orderId}/${url}`,
    () => undefined,
    (response: any) => {
      callback(response.Result);
    },
    (err: any) => callback(err),
    true,
    data
  );
}

export function getStatusOfCollectOrder(
  body: any,
  success: (response) => void
): void {
  HttpRequestGet(
    `/collect/${body.orderId}/status`,
    () => undefined,
    (response) => success(response.Result),
    () => undefined,
    true
  );
}

export interface IGetDeliveryTypeModel {
  Key: string;
  Title: string;
  Description: string;
}

export interface IGetDeliveryTypeResponseModel {
  Route: string;
  Result: IGetDeliveryTypeModel[];
}

export function getDeliveryTypes(
  success: (response: any) => void,
  failure: (error: AxiosError<any>) => void
): void {
  HttpRequestGet(
    `/collect/delivery-type`,
    () => undefined,
    (response: IGetDeliveryTypeResponseModel) => success(response.Result),
    (error: any) => failure(error),
    true
  );
}
export interface IGetHSTokenResult {
  Email: string;
  Token: string;
}
export interface IGetHSTokenResponse {
  Route: string;
  Result: IGetHSTokenResult;
}

export function getHSToken(
  success: (response: any) => void,
  failure: (error: AxiosError<any>) => void
): void {
  HttpRequestGet(
    `/hubspot/generate-token`,
    () => undefined,
    (response: IGetHSTokenResponse) => success(response.Result),
    (error: any) => failure(error),
    true
  );
};

export function markAsDeliveredRequest(
  body: { orderId: string },
  callback: (resp: any) => void,
  errCallback: (err: string) => void
) {
  HttpRequestPut(
    `/collect/${body.orderId}/mark-as-delivered`,
    () => undefined,
    (response: any) => {
      callback(response.Result);
    },
    (err: string) => errCallback(err),
    true,
    {}
  );
}

export function markAsCanceledRequest(
  body: { orderId: string },
  callback: (resp: any) => void,
  errCallback: (err: string) => void
) {
  HttpRequestPut(
    `/collect/${body.orderId}/mark-as-canceled`,
    () => undefined,
    (response: any) => {
      callback(response.Result);
    },
    (err: string) => errCallback(err),
    true,
    {}
  );
}

export function markAsFailedRequest(
  body: { orderId: string },
  callback: (resp: any) => void,
  errCallback: (err: string) => void
) {
  HttpRequestPut(
    `/collect/${body.orderId}/mark-as-failed`,
    () => undefined,
    (response: any) => {
      callback(response.Result);
    },
    (err: string) => errCallback(err),
    true,
    {}
  );
}

export interface IValidatePhoneNumberRequest {
  PhoneNumber: string;
}

export interface IValidatePhoneNumberResponse {
  Route: string;
  Result: {
    Valid: boolean;
    PhoneNumber: string;
  };
}

export function validatePhoneNumber(
  phoneNumber: string,
  success: (response: { Valid: boolean; PhoneNumber: string }) => void,
  failure: (error: string) => void
): void {
  HttpRequestPost(
    `/portal/validate-phonenumber`,
    () => undefined,
    (response: IValidatePhoneNumberResponse) => success(response.Result),
    (error: any) => {
      console.log("validatePhoneNumber error", error);
      // Extract error message from API response
      const errorMessage = error || "Invalid phone number";
      failure(errorMessage);
    },
    true,
    { PhoneNumber: phoneNumber }
  );
}
